module.exports = __webpack_public_path__ + "img/plus-blue.61d57f99.svg";